import { Pipe, PipeTransform } from '@angular/core';
import { ContentManager } from '../managers/content.manager';
import { BaseContentModel } from '../models/base.content-model';

@Pipe({
  name: 'render',
  standalone: false,
})
export class RenderPipe implements PipeTransform {

  constructor(private readonly contentManager: ContentManager) {
  }

  public static setOptions(): void {

  }

  public async transform(contentModel?: BaseContentModel, options?: any): Promise<string> {
    if (!contentModel) {
      return '';
    }

    return this.contentManager.render(contentModel, options);
  }
}
